import { Season } from '@wbk/api';
import Image from 'next/image';
import SeasonText from '@/components/season/SeasonText';

type Props = {
  season?: Season;
};

const SeasonPageBanner = ({ season }: Props) => {
  return (
    <section style={{ backgroundColor: season?.background_color }}>
      <div className='absolute -top-5 h-[700px] w-full max-w-7xl ltr:left-0 rtl:right-0'>
        <Image
          src='/images/detail-season-bg.png'
          className='object-cover opacity-[0.05]'
          fill
          alt=''
        />

        <span
          className='absolute bottom-0 right-0 block h-40 w-full'
          style={{
            background: `linear-gradient(0deg, ${season?.background_color} 0%, transparent 100%)`,
          }}
        />
        <span
          className='absolute bottom-0 right-0 block h-full w-40 rtl:hidden'
          style={{
            background: `linear-gradient(-90deg, ${season?.background_color} 0%, transparent 100%)`,
          }}
        />
        <span
          className='absolute bottom-0 left-0 block h-full w-40 ltr:hidden'
          style={{
            background: `linear-gradient(90deg, ${season?.background_color} 0%, transparent 100%)`,
          }}
        />
      </div>

      <div className='absolute -top-12 h-[1150px] w-full overflow-hidden'>
        <div
          style={{ clipPath: 'url(#blue-wave)' }}
          className='absolute inset-0 z-[8] overflow-hidden bg-tertiary ltr:-right-12 ltr:bottom-[500px] ltr:rotate-180 ltr:md:bottom-[350px] ltr:md:right-[-100px] ltr:2xl:bottom-[370px] ltr:2xl:right-0 rtl:-left-1/4 rtl:top-[-270px] rtl:md:-left-40 rtl:md:top-[-70px] rtl:xl:-left-40 rtl:xl:top-[-100px] rtl:2xl:top-[-50px]'
        >
          <div className='absolute -left-16 grid h-full w-80 grid-cols-7 opacity-30 md:left-10 md:opacity-80 ltr:-rotate-[194deg] rtl:rotate-[14deg]'>
            <div className='absolute -top-10 z-10 h-40 w-full bg-gradient-to-b from-tertiary via-tertiary/80 to-transparent' />
            <div className='absolute -bottom-10 z-10 h-40 w-full bg-gradient-to-t from-tertiary via-tertiary/80 to-transparent' />
            <div className='h-full w-[48px] animate-alnassr-chain bg-[url("/images/alnassr.png")]' />
            <div className='h-full w-[48px] animate-teams-chain bg-[url("/images/teams.png")]' />
            <div className='h-full w-[48px] animate-[alnassr-chain_20s_linear_infinite_reverse] bg-[url("/images/alnassr.png")]' />
            <div className='h-full w-[48px] animate-[teams-chain_60s_linear_infinite_reverse] bg-[url("/images/teams-2.png")]' />
            <div className='h-full w-[48px] animate-[alnassr-chain_20s_linear_infinite_reverse] bg-[url("/images/alnassr.png")]' />
            <div className='h-full w-[48px] animate-[teams-chain_80s_linear_infinite] bg-[url("/images/teams.png")]' />
            <div className='h-full w-[48px] animate-[alnassr-chain_25s_linear_infinite] bg-[url("/images/alnassr.png")]' />
          </div>
          <svg width='0' height='0'>
            <defs>
              <clipPath id='blue-wave'>
                <path
                  className='rtl:hidden'
                  d='M7.83733e-05 1396.24C7.83733e-05 1396.24 1463.03 1498.94 1233.58 1001.06C1004.13 503.184 387.812 495.711 0 0V418.31L7.83733e-05 1396.24Z'
                />
                <path
                  className='ltr:hidden'
                  d='M0 -166C0 -166 1463.03 -246.913 1233.58 145.332C1004.13 537.577 387.811 543.465 0 934.001V604.443V-166Z'
                />
              </clipPath>
            </defs>
          </svg>
        </div>
      </div>

      <div className='relative overflow-hidden'>
        <div className='container relative flex flex-col-reverse items-center p-4 md:pt-20 xl:flex-row'>
          <SeasonText backButton showTabby readMore={false} season={season} />

          {season?.promo_poster && (
            <div className='relative z-10 max-w-md'>
              <Image src={season.promo_poster} width={800} height={800} quality={100} alt='' />
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export default SeasonPageBanner;
